import { render, staticRenderFns } from "./auto-height.vue?vue&type=template&id=4d9c8fd4&scoped=true&"
import script from "./auto-height.vue?vue&type=script&lang=js&"
export * from "./auto-height.vue?vue&type=script&lang=js&"
import style0 from "./auto-height.vue?vue&type=style&index=0&id=4d9c8fd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9c8fd4",
  null
  
)

export default component.exports